import React from 'react'
import { createIcon } from '@chakra-ui/icon'

export const PlayIcon = createIcon({
  displayName: 'PlayIcon',
  path: <path fillRule="evenodd" clipRule="evenodd" d="M6.5 5V19L17.5 12L6.5 5Z" fill="currentColor" />,
  viewBox: '0 0 24 24',
})
